/*
 * File: Terms.tsx
 * Project: a-a
 * File Created: Friday, 25th October 2024 4:19:18 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 25th October 2024 4:19:48 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React from 'react';

const Terms = () => {
  return <div>Terms</div>;
};

export default Terms;
